import React from "react";
import { BsEnvelope, BsLinkedin } from "react-icons/bs";
import { FaGithub, FaSkype } from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  return (
    <footer>
      <a href="#home" className="footer__logo">
        Yousaf Z.
      </a>
      <ul className="permalinks">
        <li>
          <a href="#home">Home</a>
        </li>
        <li>
          <a href="#about">About</a>
        </li>
        <li>
          <a href="#experience">Skills</a>
        </li>
        <li>
          <a href="#portfolio">Portfolio</a>
        </li>
        <li>
          <a href="#testimonials">Testimonials</a>
        </li>
        <li>
          <a href="#contact">Contact</a>
        </li>
      </ul>
      <div className="footer__socials">
        <a
          href="mailto:mianyousafzubair@gmail.com"
          target="_blank"
          rel="noreferrer"
        >
          <BsEnvelope />
        </a>
        <a
          href="https://www.linkedin.com/in/mian-yousaf-zubair-225763211/"
          target="_blank"
          rel="noreferrer"
        >
          <BsLinkedin />
        </a>
        <a
          href="https://github.com/Yousafzubair991"
          target="_blank"
          rel="noreferrer"
        >
          <FaGithub />
        </a>
        <a
          href="https://join.skype.com/invite/CA2V6OI0hvWl"
          target="_blank"
          rel="noreferrer"
        >
          <FaSkype />
        </a>
      </div>
      <div className="footer__copyright">
        <small>&copy; All rights reserved.</small>
      </div>
    </footer>
  );
};

export default Footer;
